module.exports = __webpack_public_path__ + "img/logo_orias_radie.f062b075.png";